import { SpellDto, TranslatedText } from "../Types/ApiTypes";
import { Spell } from "../Types/TableTypes";
import i18n from "../i18n";

export function convertSpell(spell: SpellDto){
    let newSpell = {} as Spell;
    // console.log(spell);
    newSpell.description = getTranslation(spell.description) ;
    newSpell.higherLevel = getTranslation(spell.higherLevel);
    newSpell.name = spell.name["en"];
    newSpell.range = spell.range;
    newSpell.otherRange = getTranslation(spell.otherRange);
    newSpell.components = spell.components;
    newSpell.materials = getTranslation(spell.materials)
    newSpell.ritual = spell.ritual;
    newSpell.duration = getTranslation(spell.duration);
    newSpell.concentration = spell.concentration;
    newSpell.castingTime = getTranslation(spell.castingTime);
    newSpell.level = spell.level;
    newSpell.attackType = getTranslation(spell.attackType);
    // if (spell.damageType)
    newSpell.damage = {type: getTranslation(spell.damageType)};
    newSpell.dc = {type: getTranslation(spell.dcType), success: spell.dcSuccess ? getTranslation(spell.dcSuccess) : ""};
    newSpell.areaOfEffectType = getTranslation(spell.areaOfEffectType)
    newSpell.areaOfEffectSize = spell.areaOfEffectSize;

    newSpell.school = getTranslation(spell.school);
    newSpell.classes = getTranslation(spell.classes);
    newSpell.subclasses = getTranslation(spell.subclasses);

    return newSpell;
}

export function getDistanceFromFt (ftDistance: number){
    return{
        ft: ftDistance,
        sq: ftDistance / 5,
        mt: (ftDistance / 5) * 1.5,
    }
}

export function getDistanceFromMt (mtDistance: number){
    return{
        ft: (mtDistance / 1.5) * 5,
        sq: mtDistance / 1.5,
        mt: mtDistance,
    }
}

export function getDistanceFromSq (sqDistance: number){
    return{
        ft: sqDistance * 5,
        sq: sqDistance,
        mt: sqDistance * 1.5,
    }
}

export function getTranslation (text: TranslatedText, language? : string){
    if (!language){
        language = i18n.language;
    }

    return text[language] ??
        (text["en"]??
            (text["it"]??
                (Object.keys(text).length > 0 ? 
                    text[(Object.keys as unknown as string[])[0]]
                : "")));
}